import { render, staticRenderFns } from "./feedbacksixth.vue?vue&type=template&id=56668be1&scoped=true"
import script from "./feedbacksixth.vue?vue&type=script&lang=js"
export * from "./feedbacksixth.vue?vue&type=script&lang=js"
import style0 from "./feedbacksixth.vue?vue&type=style&index=0&id=56668be1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56668be1",
  null
  
)

export default component.exports